import { useMutation, type UseMutationResult } from '@tanstack/react-query';
import { MutationKey } from '@shared/config';
import { vacancyApi } from '../vacancyApi';
import type { AxiosError } from 'axios';
import type { TFormErrorResponse } from '@shared/types';
import { type DeleteVacancyTemplateParams } from '../types';

export const useDeleteVacancyTemplate = (): UseMutationResult<
  void,
  AxiosError<TFormErrorResponse>,
  DeleteVacancyTemplateParams
> => {
  return useMutation({
    mutationKey: [MutationKey.DELETE_VACANCY_TEMPLATE],
    mutationFn: (params: DeleteVacancyTemplateParams) =>
      vacancyApi.deleteVacanciesTemplate(params.ids),
  });
};
